import { MasonryPage } from 'components/masonry-page/masonry-page.component';
import { MASONRY } from 'common/constants';

export const PremiumPaymentsPage = () => (
  <MasonryPage
    screenName="Premium Payments"
    titleMessageId="STR_PREMIUM_PAYMENTS"
    rootNodeId={MASONRY.ROOT_NODE_ID_PREMIUM_PAYMENTS}
  />
);
